module.exports = __webpack_public_path__ + "img/cubik_color.e7bb853f.jpg";